import styled from "styled-components";
export const ColorSelect = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 0 15px;

  button {
    padding: 0;
    border: 0;
    background: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    ~ button {
      margin: 0 0 0 8px;
    }

    &:hover,
    &.active {
      &:before {
        opacity: 1;
      }
    }

    &:before {
      content: "";
      display: block;
      width: 6px;
      height: 10px;
      border: 2px solid #ffffff;
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg);
      position: relative;
      top: -1px;
      opacity: 0;
      transition: all 0.3s ease 0s;
    }
  }
`;
